import type { SVGProps } from 'react';
export const IconKitCloseMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width={36}
      height={36}
      rx={18}
      fill="#F0F0F0"
    />
    <path
      d="M18 18L12 12M18 18L24 12M18 18L24 24M18 18L12 24"
      stroke="#999489"
      strokeLinecap="round"
    />
  </svg>
);
